//export default {
  jQuery(window).on("load", function() {
    jQuery('.carousel-home-testimonials').each(function(){
      var items = jQuery('.carousel-item--testimonial', this);
      // reset the height
      items.css('min-height', 0);
      // set the height
      var maxHeight = Math.max.apply(null,
          items.map(function(){
              return jQuery(this).outerHeight()}).get() );
      items.css('min-height', maxHeight + 'px');
    });
  });
//};



// WEBPACK FOOTER //
// ./scripts/routes/home.js